const constants = {
  ORDER_DELIVERY_TYPE_TAKEAWAY:'takeaway',
  ORDER_DELIVERY_TYPE_STOREDELIVERY:'storeDelivery',
  ORDER_DELIVERY_TYPE_TABLE:'table',
}

export default constants
